import { WHIPClientIceServer } from "@eyevinn/whip-web-client";

export function getIceServers(): WHIPClientIceServer[] {
  let iceServers: WHIPClientIceServer[] = [{ urls: "stun:stun.l.google.com:19302" }];

  return iceServers;
}
